import { render } from "./Invoice.vue?vue&type=template&id=530c3e5c"
import script from "./Invoice.vue?vue&type=script&lang=js"
export * from "./Invoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__